import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { GridPlugin, GridPluginAttachContext } from '../../core/interfaces/grid-context.types';
import { GRID_PLUGIN } from '../../core/tokens/grid-plugin.token';

/**
 * Plugin de filtragem. Não renderiza input próprio — a tela consumidora constrói sua
 * própria UI de busca e chama `setGlobalFilter`/`setColumnFilter` via referência de
 * template (`#filter="companyFilterPlugin"`). O plugin só adiciona debounce e delega
 * ao `GridStateStore` (única fonte de verdade de filtro, ver bridge do AG Grid).
 */
@Component({
  selector: 'company-grid-filter-plugin',
  exportAs: 'companyFilterPlugin',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
  providers: [{ provide: GRID_PLUGIN, useExisting: CompanyGridFilterPlugin }],
})
export class CompanyGridFilterPlugin implements GridPlugin {
  readonly pluginId = 'filter';

  readonly caseSensitive = input(false);
  readonly debounceTime = input(300);

  private context: GridPluginAttachContext | null = null;
  private debounceHandle: ReturnType<typeof setTimeout> | null = null;

  attach(context: GridPluginAttachContext): void {
    this.context = context;
  }

  setGlobalFilter(term: string): void {
    this.debounce(() => this.context?.store.setGlobalFilter(term));
  }

  setColumnFilter(field: string, term: string): void {
    this.debounce(() => this.context?.store.setColumnFilter(field, term));
  }

  clearColumnFilter(field: string): void {
    this.context?.store.clearColumnFilter(field);
  }

  private debounce(run: () => void): void {
    if (this.debounceHandle) clearTimeout(this.debounceHandle);
    this.debounceHandle = setTimeout(run, this.debounceTime());
  }
}
